module.exports = vendor_62aa70795ec1347bc296;